import { BaseModelPagedArray } from "@eview/core/base/base-model";
import { Comments, Post } from "@eview/core/domain/post/post";

export interface CommentsState {
    comments: Array<Comments>;
}

export const initialCommentsState: CommentsState = {
    comments: []
};
